export default __webpack_public_path__ + "static/media/character_face.a899ef70.png";